/**
 * WordPress dependencies
 */
import { Circle, Rect, SVG } from '@wordpress/primitives';

export const PatreonIcon = () => (
	<SVG width="24" height="24" viewBox="0 0 569 546" version="1.1">
		<Circle cx="363" cy="205" r="205" />
		<Rect width="100" height="546" x="0" y="0" />
	</SVG>
);
